import { render, staticRenderFns } from "./GroceryStoresGridItem.vue?vue&type=template&id=f15f7f62&scoped=true&"
import script from "./GroceryStoresGridItem.vue?vue&type=script&lang=js&"
export * from "./GroceryStoresGridItem.vue?vue&type=script&lang=js&"
import style0 from "./GroceryStoresGridItem.vue?vue&type=style&index=0&id=f15f7f62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15f7f62",
  null
  
)

export default component.exports